module.exports = __webpack_public_path__ + "static/img/11.7cdbfcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/huegler/11.jpg
// module id = 385
// module chunks = 1